import React, { createContext, useContext, useMemo, useState } from "react";

const DiscoverEventsContext = createContext(null);

export function DiscoverEventsProvider({ children }) {
  const [events, setEvents] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [category, setCategory] = useState("all");
  const [focusEvent, setFocusEvent] = useState(null);
  const [searchArea, setSearchArea] = useState(null);

  const selectEvent = (event) => {
    setVisible(true);
    setCategory("all");
    setSelectedEventId(event.id);
    setFocusEvent({ id: event.id, lat: event.latitude, lng: event.longitude, key: Date.now() });
  };

  const value = useMemo(() => ({
    events, setEvents, visible, setVisible, selectedEventId, setSelectedEventId,
    category, setCategory, focusEvent, selectEvent, searchArea, setSearchArea,
  }), [events, visible, selectedEventId, category, focusEvent, searchArea]);

  return <DiscoverEventsContext.Provider value={value}>{children}</DiscoverEventsContext.Provider>;
}

// null outside Discover: park detail maps and other MapView consumers remain unchanged.
export const useDiscoverEvents = () => useContext(DiscoverEventsContext);
